export const state = () => ({
  maintenance: false,
  maintenance_msg: 'Manutenção programada para 26/04/2024, das 00:00 às 06:00',
})
